import TextInput from "../TextInput";
import Button from "../Button";
import {
  checkEmailValid,
  checkNonEmptyValues,
} from "../../utils/validation";
import { fireEmptyInputSwal, fireInvalidEmailSwal } from "../../utils/swals";
const EditarPersona = ({ periodista, setPeriodista, isOpen, setIsOpen }) => {
  const handleSubmit = () => {
    setIsOpen(false);
  };

  const checkValuesAndSubmit = () => {
    if (!checkNonEmptyValues(periodista)) {
      fireEmptyInputSwal();
    } else if (!checkEmailValid(periodista.mail)) {
      fireInvalidEmailSwal();
    } else {
      handleSubmit();
    }
  };

  return (
    <div className={`body ${isOpen ? "active" : ""}`}>
      <div className="d-col">
        <div className="d-row">
          <TextInput
            placeholder={"Nombre y apellido"}
            type={"text"}
            value={periodista.nombre}
            onChange={(e) =>
              setPeriodista((prevState) => ({
                ...prevState,
                nombre: e.target.value,
              }))
            }
          />
        </div>
        <div className="d-row">
          <TextInput
            placeholder={"DNI"}
            noDots={true}
            value={periodista.dni}
            onChange={(e) =>
              setPeriodista((prevState) => ({
                ...prevState,
                dni: e.target.value,
              }))
            }
          />
          <TextInput
            placeholder={"Cargo"}
            value={periodista.cargo}
            onChange={(e) =>
              setPeriodista((prevState) => ({
                ...prevState,
                cargo: e.target.value,
              }))
            }
          />
        </div>
        <div className="d-row">
          <TextInput
            placeholder={"Numero"}
            value={periodista.celular}
            onChange={(e) =>
              setPeriodista((prevState) => ({
                ...prevState,
                celular: e.target.value,
              }))
            }
          />
          <TextInput
            placeholder={"E-mail"}
            value={periodista.mail}
            onChange={(e) =>
              setPeriodista((prevState) => ({
                ...prevState,
                mail: e.target.value,
              }))
            }
          />
        </div>
      </div>
      <div className="mt-5">
        <Button variant={"outline-btn"} onClick={checkValuesAndSubmit}>
          <span>Editar</span>
        </Button>
      </div>
    </div>
  );
};

export default EditarPersona;
